module.exports = __webpack_public_path__ + "static/media/mukuaihua_08.3197fdfd.png";